import { openChatModal, openChatModalAfterAuth } from './openModal';
import { selectIsAuthenticated } from '../../selectors/user';
import { TThunkAction } from '../../types/redux';

type TOnOpenChatArgs = {
  offerId: number;
  gaLabel: string;
  defaultMessage?: string;
};

export const onOpenChat = ({ offerId, gaLabel, defaultMessage }: TOnOpenChatArgs): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { microfrontendsAPI } = context;
    const state = getState();
    const isUserAuthenticated = selectIsAuthenticated(state);

    if (isUserAuthenticated) {
      dispatch(openChatModal({ offerId, gaLabel, defaultMessage }));
    } else if (microfrontendsAPI) {
      dispatch(openChatModalAfterAuth({ offerId, gaLabel, defaultMessage }));
      microfrontendsAPI.header.openAuthModal();
    }
  };
};
